import React from "react";
import styles from './CursiveSpan.module.css';

interface ICursiveSpan {
  cursive?: boolean
  children: React.ReactNode
}

const CursiveSpan: React.FC<ICursiveSpan> = ({ cursive = true, children }) => (
  <span className={cursive ? styles.tdText_cursive : ''}>{children}</span>
);

export default CursiveSpan;
